module.exports = __webpack_public_path__ + "dingbeauty-build/img/404.b437dc90.svg";